import React, { useCallback } from 'react';
import { Box, Button } from '@mui/material';
import { grey } from '@mui/material/colors';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { LenderTermsComparisonRowViewModel } from '@trnsact/trnsact-shared-types';
import { MUITable, MUITableSorting } from 'components/shared/MUITable';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';

import { exportTermsComparisonToCsv, getTermsComparisonColumns, mapTermsComparisonRows } from '../../../../lib';
import { AsyncResource, ConversionTableSorting, TermsComparisonRow } from '../../../../types';

interface Props {
  sorting: ConversionTableSorting;
  resource: AsyncResource<LenderTermsComparisonRowViewModel[] | null>;
  onSortingChange: (nextValue: ConversionTableSorting) => void;
}

export const LenderTermsComparisonTable = ({ resource, sorting, onSortingChange }: Props) => {
  const tableData = mapTermsComparisonRows(resource.data ?? []);
  const columns = getTermsComparisonColumns();

  const tableSorting: MUITableSorting = {
    key: sorting.key,
    value: sorting.value,
    onChange: onSortingChange,
  };

  const handleExportCsv = useCallback(() => {
    exportTermsComparisonToCsv(tableData);
  }, [tableData]);

  return (
    <CardContainer
      title="Lender terms comparison table"
      actionBtn={
        <Button
          size="small"
          variant="outlined"
          data-pdf-exclude
          startIcon={<FileDownloadOutlinedIcon />}
          onClick={handleExportCsv}
        >
          Export CSV
        </Button>
      }
    >
      <Box
        sx={{
          '& th, & td': { border: '1px solid', borderColor: 'divider' },
          '& th': { py: 1, px: 1.5, bgcolor: grey[300] },
        }}
      >
        <MUITable<TermsComparisonRow>
          columns={columns}
          tableData={tableData}
          sorting={tableSorting}
          isLoading={!!resource.loading}
        />
      </Box>
    </CardContainer>
  );
};
